import React from 'react';
import { Section } from './Section';
import { CheckCircle2 } from 'lucide-react';
const points = ['Te gusta el rock en español y los clásicos argentinos', 'Querés un formato más cercano que un recital', 'Valorás la interpretación en vivo'];
export function ForWho() {
  return <Section data-id="element-42">
      <div className="max-w-3xl mx-auto" data-id="element-43">
        <div className="text-center mb-12" data-id="element-44">
          <h2 className="text-3xl md:text-5xl font-serif mb-4" data-id="element-45">
            Para quién es PampaNation
          </h2>
          <p className="text-xl text-amber-400/90 font-serif italic" data-id="element-46">
            Es para vos si:
          </p>
        </div>

        <div className="space-y-4" data-id="element-47">
          {points.map((point, idx) => <div key={idx} className="flex items-center gap-4 bg-surface/50 p-6 rounded-2xl border border-white/5" data-id="element-48">
              <CheckCircle2 className="w-6 h-6 text-amber-500 shrink-0" data-id="element-49" />
              <p className="text-lg text-gray-200" data-id="element-50">{point}</p>
            </div>)}
        </div>
      </div>
    </Section>;
}